import * as Sentry from '@sentry/vue'
import { defineVuePlugin } from '#/vue-plugins'

export default defineVuePlugin((app) => {
  const router = app.config.globalProperties.$router
  const VITE_SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
  Sentry.init({
    app,
    enabled: process.env.NODE_ENV === 'production',
    dsn: VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    attachStacktrace: true,
    normalizeDepth: 10,
  })
})
